import { IEnvSettings, IEnvInformation, Environment } from '../app/authentication/authSettings';

const createEnvSettings = (baseSettings: {
    authority: string;
    clientSecret: string;
    environment: Environment;
    scope: string;
    apiBaseUrl: string,
}): IEnvSettings => ({
    ...baseSettings,
    clientId: 'dxp-supervisor-view',
    rbacInterceptorUrl: baseSettings.apiBaseUrl + '/rbac',
    directoryApiUrl: baseSettings.apiBaseUrl + '/directory',
});

const devSettings: IEnvSettings = createEnvSettings({
    authority: 'https://auth-dev.telxl.net',
    clientSecret: '',
    environment: 'dev',
    scope: 'gum bp.access openid profile email',
    apiBaseUrl: 'https://api-dev.telxl.net',
});

const qaSettings: IEnvSettings = createEnvSettings({
    authority: 'https://auth-qa.telxl.net',
    clientSecret: '',
    environment: 'qa',
    scope: 'gum bp.access openid profile email',
    apiBaseUrl: 'https://api-qa.telxl.net',
});

const sandboxSettings: IEnvSettings = createEnvSettings({
    authority: 'https://auth-sand.telxl.net',
    clientSecret: '',
    environment: 'sandbox',
    scope: 'gum bp.access openid profile email',
    apiBaseUrl: 'https://api-sand.telxl.net',
});

const prodSettings: IEnvSettings = createEnvSettings({
    authority: 'https://auth.telxl.net',
    clientSecret: '',
    environment: 'prod',
    scope: 'gum bp.access openid profile email',
    apiBaseUrl: 'https://api.telxl.net',
});

const hosts: Record<Environment, string> = {
    dev: 'digital-supervisor-view-dev.telxl.net',
    qa: 'digital-supervisor-view-qa.telxl.net',
    sandbox: 'digital-supervisor-view-sand.telxl.net',
    prod: 'digital-supervisor-view.telxl.net',
};

const hostMapping: { [key: string]: IEnvSettings } = {
    'localhost': devSettings,
    [hosts.dev]: devSettings,
    [hosts.qa]: qaSettings,
    [hosts.sandbox]: sandboxSettings,
    [hosts.prod]: prodSettings,
};

export function getEnvSettings(): IEnvInformation {
    const { hostname } = window.location;
    const envSettings = hostMapping[hostname];
    if (!envSettings) {
        if (window.self === window.top) { // to avoid console spam during auth
            // eslint-disable-next-line no-console
            console.warn(`Failed to determine environment settings based on '${hostname}' host. Dev settings will be used`);
        }
        return { ...devSettings, hostname };
    }
    return { ...hostMapping[hostname], hostname };
}

export function getHostFromEnvironment(env: Environment): string {
    return hosts[env];
}

